import { React } from '@common/3rd';
import { checkAllRuntimeComponents, Widget } from '@component';
import { DeskQueryProps, JLPanel, JLSpreadSheet } from '@jl-types';
import { Modeller } from '@model';
import { CheckableWidgetCheckResult, PaginationChangeEvent, StyledPropsTheme } from '@my-types';
import { DeskContainer } from '../container/desk-container';

const empty = (props: any, theme: StyledPropsTheme) => '';


export const combine = (
	...styles: (string | ((props: any, theme: StyledPropsTheme) => string))[]
): ((props: any, theme: StyledPropsTheme) => string) => {
	if (styles == null || styles.length === 0) {
		return empty;
	}
	return function (this: any, props: any, theme: StyledPropsTheme): string {
		return styles
			.map(style => {
				if (typeof style === 'string') {
					return style;
				} else {
					return style.call(this, props, theme);
				}
			})
			.join('\n');
	};
};

class DeskQuery<P extends DeskQueryProps, S, C> extends Widget<P, S, C> {
	protected initComponents(): C {
		return {} as C;
	}
	render() {
		return <DeskContainer model={this.getModel()} layout={this.getLayout()} />;
	}
	/**
	 * 是否需要分页
	 */
	private needPagination(): boolean {
		return this.getModel().pagination != null;
	}
	private getModel() {
		return Modeller.asProxied(this.props.model);
	}
	private getLayout() {
		const layout = this.props.layout;
		return [
			{
				c: 'panel',
				header: { title: layout.criteria.title },
				body: layout.criteria.body
			} as JLPanel,
			{
				c: 'panel',
				header: { title: layout.results.title },
				body: {
					css: () => 'padding-top: 0;',
					cells: {
						c: 'panel.body.cell',
						children: {
							c: 'spread',
							css: (props: any, theme: StyledPropsTheme) => {
								return `
								flex-grow: 1;
								> div[data-widget=desk-spread-sheet-footer]{
									justify-content: flex-end;
								}`
							},
							header: layout.results.header,
							body: layout.results.body,
							footer: this.needPagination()
								? {
									children: {
										c: 'pagination',
										id: 'pagination',
										onPageChanged: this.onPageChanged
									}
								}
								: undefined
						} as JLSpreadSheet
					}
				}
			} as JLPanel
		];
	}
	getFetchFunction() {
		return this.props.fetch;
	}
	onPageChanged = (changed: PaginationChangeEvent): void => {
		const { pageNumber, pageCount, pageSize, totalCount } = changed;
		this.getFetchFunction()
			.call(this, { pageNumber, pageCount, pageSize, totalCount })
			.then(() => {
				this.forceUpdate();
			});
	};
	checkAllData(): Promise<CheckableWidgetCheckResult[] | void> {
		return checkAllRuntimeComponents();
	}
}

export { DeskQuery };
